export enum SIGN_ERROR_CODES {
  PHONE_NUMBER_ERROR = 'phone_no_error',
  PERSONAL_NUMBER_ERROR = 'personal_no_error',
  VERIFICATION_METHOD_ERROR = 'verification_method_error',
  STATE_MACHINE_ERROR = 'state_machine_error',
  ORDER_STATUS_ERROR = 'order_status_error',
}
